import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterAmplifyMemberships = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.amplifyMemberships
)
